require('./lte-interface-1.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { MODE_RACCORDEMENT, TYPE_LOGEMENT, OUI_NON, OUI_NON_NSP } from '../../../common/model';
import { CIVILITE } from '../../../base/model';
import { STEPS } from '../../../../utils/routes.util';
import { EMAIL_PATTERN, TELEPHONE_PATTERN } from '../../../../utils/pattern.util';

export default class LteInterface1Component {
  constructor() {
    this.controller = LteInterface1Controller;
    this.template = require('./lte-interface-1.html');
  }
}

// @ngInject
class LteInterface1Controller {

  constructor($scope, $ngRedux) {
    this.CIVILITE = CIVILITE;
    this.MODE_RACCORDEMENT = MODE_RACCORDEMENT;
    this.TYPE_LOGEMENT = TYPE_LOGEMENT;
    this.OUI_NON = OUI_NON;
    this.OUI_NON_NSP = OUI_NON_NSP;
    this.regex = new RegExp(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/, 'u');
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.emailPattern = EMAIL_PATTERN;
    this.telephonePattern = TELEPHONE_PATTERN;
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.LTE_INTERFACE_1));

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          typePersonne: state.demande.data.typePersonne,
          data: state.demande.data.lteInterface1 ? state.demande.data.lteInterface1.asMutable({deep: true}) : this.data
        };
      }
    )(this);
    this.data = {civilite: CIVILITE.DEFAULT_VALUE ,
      modeRaccordement: MODE_RACCORDEMENT.DEFAULT_VALUE,
      typeLogement: TYPE_LOGEMENT.DEFAULT_VALUE,
      voisinsImpactes: OUI_NON_NSP.DEFAULT_VALUE};
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  defineRaccordement() {
    if (this.data.modeRaccordement === MODE_RACCORDEMENT.NSP) {
      if (this.data.typeLogement === TYPE_LOGEMENT.IMMEUBLE) {
        this.data.modeRaccordement = MODE_RACCORDEMENT.COLLECTIF;
      } else {
        this.data.modeRaccordement = MODE_RACCORDEMENT.INDIVIDUEL;
      }
    }
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateLteInterface1(this.data, true));
  }
  nextStep() {
    this.defineRaccordement();
    this.$ngRedux.dispatch(DemandeActions.updateLteInterface1(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/lte/components/lte-interface-1/lte-interface-1.component.js